"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Map = exports.MapContext = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var React = _interopRequireWildcard(require("react"));

var _react2 = require("@emotion/react");

var mapboxgl = _interopRequireWildcard(require("mapbox-gl"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n          height: ", ";\n          width: ", ";\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MapContext = /*#__PURE__*/React.createContext(null);
exports.MapContext = MapContext;

var Map = function Map(_ref) {
  var container = _ref.container,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? 'mapbox://styles/mapbox/streets-v11' : _ref$style,
      accessToken = _ref.accessToken,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "700px" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "500px" : _ref$height,
      _ref$center = _ref.center,
      center = _ref$center === void 0 ? [-70.944, 42.37] : _ref$center,
      _ref$zoom = _ref.zoom,
      zoom = _ref$zoom === void 0 ? 8.4 : _ref$zoom,
      _ref$minZoom = _ref.minZoom,
      minZoom = _ref$minZoom === void 0 ? 8 : _ref$minZoom,
      _ref$maxZoom = _ref.maxZoom,
      maxZoom = _ref$maxZoom === void 0 ? 16 : _ref$maxZoom,
      onClick = _ref.onClick,
      children = _ref.children;
  var mapRef = React.useRef(null);

  var _React$useState = React.useState(null),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      map = _React$useState2[0],
      setMap = _React$useState2[1];

  React.useEffect(function () {
    if (!map) {
      var mapObj = new mapboxgl.Map({
        container: container,
        style: style,
        accessToken: accessToken,
        zoom: zoom,
        center: center,
        maxZoom: maxZoom,
        minZoom: minZoom
      });
      setMap(mapObj);
    }

    return function () {
      if (map) {
        map === null || map === void 0 ? void 0 : map.remove();
        setMap(null);
      }
    };
  }, [map, minZoom, maxZoom, center, style, accessToken, zoom, container]);
  React.useEffect(function () {
    if (map && onClick) {
      map.on('click', function (e) {
        e.features = map.queryRenderedFeatures([e.point.x, e.point.y]);
        return onClick(e);
      });
    }
  }, [map, onClick]);
  return (0, _react2.jsx)(MapContext.Provider, {
    value: map
  }, (0, _react2.jsx)("div", {
    ref: mapRef,
    id: container,
    css: (0, _react2.css)(_templateObject(), height, width)
  }, children));
};

exports.Map = Map;